import { render, staticRenderFns } from "./HomePhotos.vue?vue&type=template&id=6638b051&scoped=true&"
import script from "./HomePhotos.vue?vue&type=script&lang=ts&"
export * from "./HomePhotos.vue?vue&type=script&lang=ts&"
import style0 from "./HomePhotos.vue?vue&type=style&index=0&id=6638b051&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638b051",
  null
  
)

export default component.exports